import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './../views/Home/indexHome'
import Userinfo from './../views/User/userinfoIndex'

import Driver from './../views/Driver/driverList'
import Driverdetail from './../views/Driver/driverDetail'
import Adddriver from './../views/Driver/addDriver'
import Editdriver from './../views/Driver/editDriver'

import Escort from './../views/Escort/escortList'
import Escortdetail from './../views/Escort/escortDetail'
import Addescort from './../views/Escort/addEscort'
import Editescort from './../views/Escort/editEscort'

import Vehicle from './../views/Vehicle/vehicleIndex'

import Addchetou from './../views/Vehicle/addChetou'
import Editchetou from './../views/Vehicle/editChetou'
import Chetoudetail from './../views/Vehicle/chetouDetail'

import Addchegua from './../views/Vehicle/addChegua'
import Cheguadetail from './../views/Vehicle/cheguaDetail'
import Editchegua from './../views/Vehicle/editChegua'

import Appointment from './../views/Appointment/appointmentIndex'
import AppointmentTh from './../views/Appointment/appointmentTh'
import AppointmentXh from './../views/Appointment/appointmentXh'

import Orderlist from './../views/Order/orderList'
import Orderdetail from './../views/Order/orderDetail'

import Uploadth from './../views/Public/uploadTh'
import UploadDelivery from './../views/Order/uploadDelivery'

import NotificationItem from './../views/Notification/notificationItem'

Vue.use(VueRouter)

const routes = [{
    path: "/", //路径
    name: "index",
    component: Home, //组件
    meta: {
      title: '槽车在线预约入库平台'
    }
  },
  {
    path: "/Userinfo",
    name: "userinfo",
    component: Userinfo,
    meta: {
      // 页面标题title
      title: '用户信息'
    }
  },
  {
    path: "/Driver",
    name: "driver",
    component: Driver,
    meta: {
      title: '驾驶员备案'
    }
  },
  {
    path: "/driverdetail/:id/",
    name: "driverdetail",
    component: Driverdetail,
    meta: {
      title: '驾驶员备案详情'
    }
  },
  {
    path: "/adddriver",
    name: "adddriver",
    component: Adddriver,
    meta: {
      title: '新增驾驶员备案'
    }
  },
  {
    path: "/editdriver/:id/",
    name: "editdriver",
    component: Editdriver,
    meta: {
      title: '编辑驾驶员备案'
    }
  },
  {
    path: "/Escort",
    name: "escort",
    component: Escort,
    meta: {
      title: '备案押运员'
    }
  },
  {
    path: "/addescort",
    name: "addescort",
    component: Addescort,
    meta: {
      title: '押运员备案'
    }
  },
  {
    path: "/escortdetail/:id/",
    name: "escortdetail",
    component: Escortdetail,
    meta: {
      title: '押运员备案详情'
    }
  },
  {
    path: "/editescort/:id/",
    name: "editescort",
    component: Editescort,
    meta: {
      title: '编辑押运员备案'
    }
  },
  {
    path: "/Vehicle/:type/",
    name: "vehicle",
    component: Vehicle,
    meta: {
      title: '车辆管理'
    }
  },
  {
    path: "/addchetou",
    name: "addchetou",
    component: Addchetou,
    meta: {
      title: '新增车头备案'
    }
  },
  {
    path: "/editchetou/:id/",
    name: "editchetou",
    component: Editchetou,
    meta: {
      title: '编辑车头备案'
    }
  },
  {
    path: "/addchegua",
    name: "addchegua",
    component: Addchegua,
    meta: {
      title: '新增车挂备案'
    }
  },
  {
    path: "/chetoudetail/:id/",
    name: "chetoudetail",
    component: Chetoudetail,
    meta: {
      title: '车头详情'
    }
  },
  {
    path: "/cheguadetail/:id/",
    name: "cheguadetail",
    component: Cheguadetail,
    meta: {
      title: '车挂详情'
    }
  },
  {
    path: "/editchegua/:id/",
    name: "editchegua",
    component: Editchegua,
    meta: {
      title: '编辑车挂备案'
    }
  },
  {
    path: "/appointment/:type/",
    name: "appointment",
    component: Appointment,
    meta: {
      title: '预约提货'
    }
  },
  {
    path: "/appointmentTh/:inputBillNo/:chetouhao/:cheguahao/:driverNo/:escortNo/",
    name: "appointmentTh",
    component: AppointmentTh,
    meta: {
      title: '提货订单'
    }
  },
  {
    path: "/appointmentXh/:inputBillNo/:chetouhao/:cheguahao/:driverNo/:escortNo/",
    name: "appointmentXh",
    component: AppointmentXh,
    meta: {
      title: '卸货订单'
    }
  },
  {
    path: "/Order",
    name: "orderlist",
    component: Orderlist,
    meta: {
      title: '订单列表'
    }
  },
  {
    path: "/Order/orderdetail/:id/",
    name: "orderdetail",
    component: Orderdetail,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: "/uploadth/:id/",
    name: "uploadth",
    component: Uploadth,
    meta: {
      title: '上传电子运单'
    }
  },
  {
    path: "/upload-delivery/:id/",
    name: "uploadDelivery",
    component: UploadDelivery,
    meta: {
      title: '上传送货单'
    }
  },
  {
    path: "/notificationDetail/id/:id",
    name: "notification",
    component: NotificationItem,
    meta: {
      title: '消息通知'
    }
  },
  // {
  //   path: "/Public",
  //   name: "searchChetou",
  //   component: SearchChetou,
  //   meta: {
  //     title: '搜索车头号'
  //   }
  // },
  // {
  //   path: "/Public",
  //   name: "searchChegua",
  //   component: SearchChegua,
  //   meta: {
  //     title: '搜索车挂号'
  //   }
  // },
  // {



  // {
  //   path: "/Appointmentxh",
  //   name: "appointmentxh",
  //   component: Appointmentxh,
  //   meta: {
  //     title: '卸货预约'
  //   }
  // },
  // {
  //   path: "/protocol",
  //   name: "protocol",
  //   component: UserProtocol,
  //   meta: {
  //     title: '预约排队提货守则'
  //   }
  // },
  // {
  //   path: "/userprotocol",
  //   name: "userprotocol",
  //   component: UserProtocol2,
  //   meta: {
  //     title: '预约排队提货守则'
  //   }
  // },
  // {
  //   path: "/appointmentxy",
  //   name: "appointmentxy",
  //   component: Appointmentxy,
  //   meta: {
  //     title: '协议'
  //   }
  // }
  // ,

]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
